//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ApartmentPopup',
  props: ['apartment', 'isVisible', 'investmentId'],
  data: function() {
    return {
      status: this.apartment.status.toLowerCase(),
      isReserved: this.status == 'rezerwacja',
      isAvailable: this.status == 'wolne',
      isSold: this.status == 'sprzedane',
    };
  },

  computed: {
    isSold() {
      return this.apartment.status.toLowerCase() == 'sprzedane';
    },

    pricePerSqm() {
      // Remove 'zł' or 'PLN' from price string and parse as float
      const price = parseFloat(
        String(this.apartment.price)
          .replace(/[\s,]*(zł|PLN)/gi, '')
          .replace(/\s/g, '')
          .replace(',', '.')
      );

      const area = parseFloat(this.apartment.area.replace(',', '.'));
      return (price / area).toFixed(2);
    },
  },

  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
    handleFormOpen() {
      this.$emit('openForm', this.apartment.id);
    },
    handlePriceHistoryClick() {
      this.$emit('showPriceHistory', {
        apartmentId: this.apartment.id,
        investmentId: this.investmentId,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/partials/ApartmentPopup.vue